export  const actionTypes = {
    LOGIN_REQUEST: 'LOGIN_REQUEST',
    LOGIN_SUCCESS: 'LOGIN_SUCCESS',
    LOGIN_ERROR: 'LOGIN_ERROR',
    LOGOUT: 'LOGOUT'
}

export const initialState = {
    phone: null,
    name: null ,
    isEhraz: false,
    loading: false,
    isAuth: false,
    error: null
}

export function reducer(state,action){
    switch (action.type){
        case actionTypes.LOGIN_REQUEST:
            return{
                ...state,
                phone: null,
                name: null ,
                isEhraz: false,
                loading: true,
                isAuth: false,
                error: null

            }
        case actionTypes.LOGIN_SUCCESS:
            const {phone,name,isEhraz} = action.payload
            return{
                ...state,
                phone: phone,
                name: name,
                isEhraz: isEhraz,
                isAuth: true,
                loading: false,
                error: null

            }
        case actionTypes.LOGIN_ERROR:
            return{
                ...state,
                phone: null,
                name: null,
                isEhraz: false,
                isAuth: false,
                loading: false,
                error: null

            }
        case actionTypes.LOGOUT:
            return{
                ...state,
                    phone: null,
                    name: null ,
                    isEhraz: false,
                    loading: false,
                    isAuth: false,
                    error: null

            }
        default:
            throw Error("action not supported........")

    }
}